var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('div',{staticClass:"loading-view"},[_c('Spinner',{staticClass:"center gray"}),_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }